import { customCursor } from "./components/custom-cursor";
import { scrollProgressMain } from "./components/scroll-progress";
import { mainLogo, showGreeting, showMainLogo } from "./modules/main-logo";
import { menuButton } from "./modules/menu-button";
import { setHeaderProps, layoutScroll, setHTMLClass } from "./modules/layout";
import { teamSlide } from "./components/team-slide";
import { cccSvg } from "./modules/ccc-svg";
import { doubtsSlide } from "./components/doubts-slide";
import { ideaSlide } from "./components/idea-slide";
import {
	offZooSlide,
	offZooSlideStyles,
	offZooHoverImage,
} from "./components/off-zoo-slide";
import { slideText, slideTextStyles } from "./components/slide-text";
import { slideExitos } from "./components/slide-exitos";
import { followImage } from "./components/follow-image";
import { tabsService } from "./components/services-tabs";
import { seoTextSlide } from "./components/seo-slide";
import { seoListSolutions } from "./components/seo-list-solutions";
import { logoSlider } from "./components/logo-slider";
import { initAnimations } from "./animations/init-animations";
import { sliderQueryLoopMovil } from "./components/slider-query-loop";
import { homeFaqs } from "./components/home-faqs";
import {
	textAnimationBlog,
	textAnimationBlogSlider,
} from "./ajax-scripts/text-animation-blog";
import { replaceLocationSVG } from "./components/svg-location";
import { projectShowcase } from "./components/project-showcase";
import { SmoothScroll } from "./modules/smooth-scroll.js";
import { hiddenControlVimeo } from "./components/hidden-control-vimeo.js";
import { headingTexture } from "./components/heading-texture.js";
import { stackingCards } from "./components/stacking-cards";
import { verticalTabs } from "./components/vertical-tabs";
import { steamAnimation } from "./animations/steam-animation.js";
import { scrollBg } from "./components/scroll-bg.js";
import { singlePost } from "./components/single-post";
import { threadsBackground } from "./components/threads-bg";
import { helpTabs } from "./components/help-tabs";
import { mainMenuHover } from "./components/main-menu-hover";
import { contactExperience } from "./components/contact-experience";
import { contactFormTabs } from "./components/contact-form-tabs";
import { menuCloseCustom } from "./components/menu-close-custom";
import { mainMenuMobil } from "./components/main-menu-mobil.js";
import { sitemap } from "./components/sitemap";
import { SeoListServices } from "./modules/seo-list-services";

// import { ProjectRotation } from "./components/project-slide.js";
// import { testimonials } from "./components/testimonials";
// import { tabFeatures } from "./components/tab-features";

setHTMLClass();

document.addEventListener("DOMContentLoaded", () => {
	const body = document.querySelector("body");
	scrollProgressMain();
	customCursor();
	setHeaderProps();
	layoutScroll();
	menuButton();
	slideText();
	slideExitos();
	seoTextSlide();
	seoListSolutions();
	logoSlider();
	followImage();
	offZooSlide();
	tabsService();
	// tabFeatures();
	offZooHoverImage();
	sliderQueryLoopMovil();
	// testimonials();
	projectShowcase();
	homeFaqs();
	textAnimationBlog();
	textAnimationBlogSlider();
	SmoothScroll();
	// ProjectRotation();
	hiddenControlVimeo();
	headingTexture();
	stackingCards();
	verticalTabs();
	steamAnimation();
	scrollBg();
	singlePost();
	threadsBackground();
	helpTabs();
	mainMenuHover();
	contactExperience();
	contactFormTabs();
	replaceLocationSVG();
	menuCloseCustom();
	mainMenuMobil();
	sitemap();
	SeoListServices();

	if (body.classList.contains("home")) {
		mainLogo(body);
		showGreeting();
		cccSvg();
		showMainLogo(webobj.time_lap);
		ideaSlide();
		teamSlide();
		doubtsSlide();
	}

	initAnimations();
});

window.addEventListener("resize", () => {
	if (!document.body.classList.contains("wp-admin")) {
		setHeaderProps();
		offZooSlideStyles();
		slideTextStyles();
		projectShowcase();
	}
});
